<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/usReviewHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">{{blogs.state}} Bookmaker Reviews</h2>
                        <h4>USA Review</h4>

                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>
                    
                <div class="row">
                    <div class="col-md-8">

                <div v-html="blogs.content" />

                <h3>Sports betting apps</h3>

                          <div class="row">
                            <div v-for='review in usaReviews' :key="review.id" class="col-md-6">
                                <div class="card card-blog">
                                    <div class="card-image">
                                        <router-link v-bind:to="{name: 'review-detail-USA', params: { item_id: review.id }}">
                                             <img class="img rounded" :src="review.logo"> 
                                        </router-link>
                                        <!-- <a href="#pablo">
                                            <img class="img rounded" :src="review.logo">
                                        </a> -->
                                    </div>
                                    <div class="card-body">
                                        <!-- <h6 class="category text-primary">Features</h6>
                                        <h5 class="card-title">
                                            That’s One Way To Ditch Your Passenger
                                        </h5> -->
                                        <p class="card-description">
                                            {{review.content}}
                                        </p>

                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point1}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point2}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point3}}
                                            </div>
                                        </div>


                                        <div class="card-footer">
                                            <a :href="review.buttonLink" target="_blank" class="btn-block btn btn-primary" >
                                            {{review.button}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>



                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'
  import Sidebar from '@/pages/bet/sidebarUs';
  
  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Card,
      Sidebar,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        year: new Date().getFullYear(),
        usaReviews: [],
        state_id: null,
        blogs: {
          state: null,
          content: null
        }
      }
    }, 
    beforeRouteEnter(to, from, next) {

    db.collection('usaReviewsMain').where('state', '==', to.params.state_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {

                vm.usaReviews = [];
                vm.blogs.state = null;
                vm.blogs.content = null;

                const data = {
                'id': doc.id,
                'logo': doc.data().logo,
                'content': doc.data().content,
                'point1': doc.data().point1,
                'point2': doc.data().point2,
                'point3': doc.data().point3,
                'button': doc.data().button,
                'buttonLink': doc.data().buttonLink
                }
                vm.usaReviews.push(data)


          });
        });
      });

    db.collection('usaStates').where('name', '==', to.params.state_id).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
        vm.blogs.state = doc.data().name;
        vm.blogs.content = doc.data().content;

          });
        });
      });

  },
   watch: {
    $route: 'fetchData'
  },
  methods:{
          fetchData () {
      this.usaReviews = [];
      db.collection('usaReviewsMain')
        .where('state', '==', this.$route.params.state_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {

                this.usaReviews.push({
                    'id': doc.id,
                    'logo': doc.data().logo,
                    'content': doc.data().content,
                    'point1': doc.data().point1,
                    'point2': doc.data().point2,
                    'point3': doc.data().point3,
                    'button': doc.data().button,
                    'buttonLink': doc.data().buttonLink
                    });
          });
        });
        this.blogs.state = null;
        this.blogs.content = null;
      db.collection('usaStates')
        .where('name', '==', this.$route.params.state_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {

        this.blogs.state = doc.data().name;
        this.blogs.content = doc.data().content;

          });
        });



    },
  }

  }
</script>
<style>
</style>
